var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 844,
    height: 1014,
    viewBox: "0 0 844 1014",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_769_8820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9153 254.2L424.96 24.5255L830.086 254.146V736.227L424.959 977.05L13.9153 736.172V254.2Z",
    fill: "white",
    stroke: "#504D64",
    strokeWidth: 26.314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.329 976.348L144.616 811.517V322.679L426.276 157.025L699.384 322.564V814.238L426.329 976.348Z",
    fill: "#FEE175",
    stroke: "#504D64",
    strokeWidth: 26.314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.406 885.345V406.909L425.152 309.834L576.594 406.757V885.494L425.158 976.356L267.406 885.345Z",
    fill: "#FAC914",
    stroke: "#504D64",
    strokeWidth: 26.314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.051 402.959L425.29 468.119M425.29 981.241V468.119M578.027 402.961L425.29 468.119",
    stroke: "#504D64",
    strokeWidth: 26.314
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_769_8820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 842.047,
    height: 1013.09,
    fill: "white",
    transform: "translate(0.976746 0.912781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.85d0e917de6745f528ff004e881b7588.svg";
export { ForwardRef as ReactComponent };